import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';

import { CmsTranslationDirective } from '../../../cms/directives/cms-translation.directive';

export type UpdateDialogResult = 'update' | 'postpone';

@Component({
  selector: 'app-update-dialog',
  imports: [
    CmsTranslationDirective,
    MatDialogContent,
    MatDialogActions,
    MatButton,
  ],
  templateUrl: './update-dialog.component.html',
  styleUrl: './update-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<UpdateDialogComponent>);

  onSubmit(): void {
    this.dialogRef.close('update' satisfies UpdateDialogResult);
  }

  onPostpone(): void {
    this.dialogRef.close('postpone' satisfies UpdateDialogResult);
  }
}
